import type { ProjectStatusId } from '@witmetrics/utils';
import { PROJECT_STATUSES } from '@witmetrics/utils/constants';
import { API } from '@/api';

export const classes = {
  button:
    'text-grey-8 dark:text-mauve-1 text-base place-start cursor-pointer py-2 pl-2 pr-4 bg-transparent rounded-lg hover:bg-grey-3 dark:hover:bg-white/[0.1] transition-colors outline-none',
  projectStatusCircle: 'mr-2 text-taupe-2 dark:text-mauve-2',
  label: 'text-base font-medium',
};

export function updateProjectStatus(
  projectId: number,
  unisonProjectStatusId: ProjectStatusId
) {
  return API.UnisonProjects.updateUnisonProject(projectId, {
    unisonProjectStatusId,
  });
}

export function getStatusLabel(projectStatusId: ProjectStatusId) {
  return Object.values(PROJECT_STATUSES).find((s) => s.id === projectStatusId)!
    .label;
}
